module.exports = __webpack_public_path__ + "img/bl_gray.4a4193c2.png";